//changed due to package upgrade
import React, { useState, useEffect, useMemo } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  TableCell,
  alpha,
  styled,
  useMediaQuery,
  Dialog,
  DialogTitle,
  Typography,
  DialogContent,
  Grid,
  DialogContentText,
  DialogActions,
  MenuItem,
  Modal,
  TextField,
  IconButton,
  Autocomplete,
} from '@mui/material';
import AppsPagination from '@projectK/components/AppsPagination';
import jwtAxios from '@projectK/services/auth/JWT';
import { useIntl } from 'react-intl';
import AppLoader from '@projectK/components/AppLoader';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import AppSearchBar from '@projectK/components/AppSearchBar';
import AppsHeader from '@projectK/components/AppsHeader';
import AppScrollbar from '@projectK/components/AppScrollbar';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import productThemes from '@projectK/constants/ProductThemes';
import { useNavigate } from 'react-router-dom';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import CloseIcon from '@mui/icons-material/Close';
import { encrypt } from '@projectK/modules/apps/encryption';
import PropTypes from 'prop-types';
import {
  ActivityScheduleMain,
  SortingModalActivityMain,
} from '@projectK/MainComponents';
import { UnfoldMoreOutlined } from '@mui/icons-material';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import {
  IsDateFormatString,
  timeZoneDate,
} from '@projectK/modules/apps/DateFormat';
import {
  isSuperAdmin,
  isParent,
  isAdmin,
} from '@projectK/context/RolesProvider';
import RestrictedPopupDialog from '@projectK/modules/apps/RestrictedPopupDialog';
import WaitlistModal from '../ProductView/WaitlistModal';
import {
  ProductProfileFieldsGrid,
  validateProductProfileFields,
  serializeProductProfileFieldsPayload,
  mapUserProfileDataToFormValues,
  getProfileFieldsStructureKey,
} from '../../../profileFields';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 5,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },

  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },

  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },

    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));


const ActivitySchedule = ({ product_Id, product, purchaseOptions, slug }) => {//NOSONAR
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { isMobile } = useMobileSettings();
  const companyTheme = CompanyTheme();
  const { verbiageSettings } = useApplicationSettings();
  const { messages } = useIntl();
  const mobileResponsive = useMediaQuery('(max-width:836px)');
  const [list, setList] = useState([]);
  const [total, setTotal] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const infoViewActionsContext = useInfoViewActionsContext();
  const { user } = useAuthUser();
  const navigate = useNavigate();
  const [isFreePopupOpen, setIsFreePopupOpen] = useState(false);
  const [freePurchaseOption, setFreePurchaseOption] = useState(null);
  const [freeProductId, setFreeProductId] = useState(null);
  const [activityNameSorting, setActivityNameSorting] = useState(null);
  const [startDateSorting, setStartDateSorting] = useState(null);
  const [startTimeSorting, setStartTimeSorting] = useState(null);
  const [locationSorting, setLocationSorting] = useState(null);
  const [resourceSorting, setResourceSorting] = useState(null);
  const [membersData, setMembersData] = useState([]);
  const [childId, setChildId] = useState(null);
  const [isChildIdValid, setIsChildIdValid] = useState(false); // Add state for validation  const [loading, setLoading] = useState(true);
  const [profileFields, setProfileFields] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [requiredProfileFields, setRequiredProfileFields] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(null);
  const [waivers, setWaivers] = useState([]);
  const [openSortingModal, setOpenSortingModal] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const handleInputChange = (field, valueOrEvent) => {
    const value =
      valueOrEvent?.target !== undefined
        ? valueOrEvent.target.value
        : valueOrEvent;
    const fieldId = field?.profile_field_id;
    setFormValues((prev) => ({
      ...prev,
      [fieldId]: value,
    }));
    if (fieldErrors[fieldId]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[fieldId];
        return next;
      });
    }
  };
  const selectedTheme = productThemes.find(
    (theme) => theme.title === product?.displaySettings?.product_theme,
  );
  const handleConditionFunction = (condition, ifData, elseData) => {
    if (condition) {
      return ifData;
    } else {
      return elseData;
    }
  };
  const isProductLimit = handleConditionFunction(
    product?.purchase_limit !== null && product?.purchase_limit !== undefined,
    product.purchased_count >= product.purchase_limit,
    false,
  );

  const fetchSettings = async () => {
    try {
      setLoading(true);

      const response = await jwtAxios.get(
        user?.id
          ? `/activity-session/product/all-sessions/${product_Id}`
          : `/public/activity-session/product/all-sessions/${product_Id}`,
        {
          params: {
            page,
            search,
            user_id: user?.id,
            sortings: {
              activity_name: activityNameSorting,
              start_date: startDateSorting,
              start_time: startTimeSorting,
              location_name: locationSorting,
              resource_name: resourceSorting,
            },
          },
        },
      );
      const { data } = response;
      const updatedData = data?.list?.map((data) => ({
        ...data,
        activity_name: data.activity_display_name
          ? data.activity_display_name
          : data.activity_name,
      }));
      setList(updatedData);
      setTotal(data.total);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (product_Id) {
      fetchSettings();
    }
  }, [
    page,
    search,
    activityNameSorting,
    startDateSorting,
    startTimeSorting,
    locationSorting,
    resourceSorting,
    product_Id,
  ]);

  const onSearchActivity = (e) => {
    setSearch(e.target.value);
    setPage(0);
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };
  const handleSignUp = async (user_id, id, product_id) => {
    try {
      setLoading(true);
      // Make the POST request using jwtAxios
      await jwtAxios.post(`/user-session`, {
        user_id: user_id,
        activity_session_id: id,
        product_id: product_id,
      });
      setLoading(false);
      fetchSettings();
      infoViewActionsContext.showMessage(`Signed up to session successfully`);
    } catch (error) {
      setLoading(false);
      if (error.status === 423) {
        setIsErrorDialogOpen(true);
      } else {
        infoViewActionsContext.fetchError(error.response.data.error);
      }
    }
  };

  const handleWaitlist = async (user_id, id, product_id) => {
    try {
      setLoading(true);
      // Make the POST request using jwtAxios
      await jwtAxios.post(`/user-waitlist`, {
        user_id: user_id,
        activity_session_id: id,
        product_id: product_id,
      });
      setLoading(false);
      fetchSettings();
      infoViewActionsContext.showMessage(
        `Session added to waitlist successfully`,
      );
    } catch (error) {
      setLoading(false);
      if (error.status === 423) {
        setIsErrorDialogOpen(true);
      } else {
        infoViewActionsContext.fetchError(error.response.data.error);
      }
    }
  };

  const handleSort = (column) => {
    setActivityNameSorting(
      column === 'activity_name' ? !activityNameSorting : null,
    );
    setStartDateSorting(column === 'start_date' ? !startDateSorting : null);
    setStartTimeSorting(column === 'start_time' ? !startTimeSorting : null);
    setLocationSorting(column === 'location_name' ? !locationSorting : null);
    setResourceSorting(column === 'resource_name' ? !resourceSorting : null);
  };

  const [popupOpen, setPopupOpen] = useState(false);

  const handlePopUp = (itemId) => {
    setPopupOpen(true);
  };

  const handleCancelPopUp = () => {
    setPopupOpen(false);
  };
  const todayDate = timeZoneDate().todayDate.toFormat('yyyy-MM-dd');
  const checkIfPackageExpired = async () => {
    const todayDate = timeZoneDate().todayDate.toFormat('yyyy-MM-dd');
    const productExpired = product?.expiry_date
      ? (await IsDateFormatString(product?.expiry_date)).split('T')[0] <
        todayDate
      : false;

    return productExpired;
  };

  const checkIfPurchaseOptionExpired = async (purchaseOption) => {
    const balancePaymentDue = purchaseOption?.balance_payment_due_date;
    if (balancePaymentDue) {
      const balancePaymentDueDate = balancePaymentDue
        ? (await IsDateFormatString(balancePaymentDue)).split('T')[0] <
          todayDate
        : false;
      if (balancePaymentDueDate) {
        infoViewActionsContext.fetchError(
          'You cannot purchase this product, Please contact your administartor.',
        );
        return true;
      }
    } else if (purchaseOption?.is_deposit === 1 && !balancePaymentDue) {
      infoViewActionsContext.fetchError(
        'You cannot purchase this product, Please contact your administartor.',
      );
      return true;
    }
    const purchaseOptionExpiryto =
      purchaseOption?.estimated_offline_purchase_to;
    const purchaseOptionExpiryfrom =
      purchaseOption?.estimated_offline_purchase_from;
    const Ispurchaseto = purchaseOptionExpiryto
      ? (await IsDateFormatString(purchaseOptionExpiryto)).split('T')[0] <
        todayDate
      : false;
    if (Ispurchaseto) {
      infoViewActionsContext.fetchError('Purchase option is expired');
      return true;
    }
    const IspurchaseFrom = purchaseOptionExpiryfrom
      ? (await IsDateFormatString(purchaseOptionExpiryfrom)).split('T')[0] >
        todayDate
      : false;
    if (IspurchaseFrom) {
      infoViewActionsContext.fetchError('Purchase option is not started');
      return true;
    }
    return false;
  };
  const onAddToCard = async (
    price,
    payment_plan_id,
    product_purchase_id,
    product_ID,
    is_deposit,
    remaining_amount,
  ) => {
    if (await checkIfPackageExpired()) {
      infoViewActionsContext.fetchError('Product is expired');
      return;
    }

    const purchaseOption = purchaseOptions.find(
      (purchaseOption) => purchaseOption.id === product_purchase_id,
    );
    if (await checkIfPurchaseOptionExpired(purchaseOption)) return;

    if (price === '0.00' || price === 0) {
      setIsFreePopupOpen(true);
      setFreePurchaseOption(product_purchase_id);
      setFreeProductId(product_ID);
      return;
    }
    try {
      // Make the POST request using jwtAxios
      const encrypteData = await encrypt('activtyschedule');
      await jwtAxios.post(`/cart/`, {
        product_id: product.id,
        quantity: 1,
        is_deposit: is_deposit === 1,
        remaining_amount: remaining_amount,
        item_price: price,
        ...(payment_plan_id && { payment_plan_id }),
        ...(product_purchase_id && { product_purchase_id }),
        iscartupdated: encrypteData,
        user_id: user.id,
      });
      infoViewActionsContext.showMessage(
        `${product.product_name} added to cart successfully`,
      );
      navigate('/cart');
    } catch (error) {
      if (error.status === 423) {
        setIsErrorDialogOpen(true);
      } else {
        infoViewActionsContext.fetchError(error?.response?.data?.error);
      }
    }
  };

  const handleClosePopup = () => {
    setIsFreePopupOpen(false);
    setFormSubmitted(false);
    setFieldErrors({});
    setChildId('');
    setSelectedUsers(null);
    setWaivers([]);
  };
  useEffect(() => {
    fetchMembersData();
  }, []);
  const fetchMembersData = async () => {
    try {
      const response = await jwtAxios.get(`/user-members/${user.id}`, {
        params: {
          perPage: 'all',
        },
      });
      const { data } = response;
      setMembersData(data?.list || []);
    } catch (error) {
      setMembersData([]);
    }
  };
  // Validation logic for the TextField
  useEffect(() => {
    setIsChildIdValid(!!childId); // Simple validation: Check if childId is not null or empty
  }, [childId]);
  const isProductFree = (option) => {
    return (
      (option?.purchase_price === '0.00' || option?.purchase_price === 0) &&
      (option?.monthly_price === '0.00' || option?.monthly_price === 0)
    );
  };

  const getTextForRole = (role, isFree) => {
    if (role === 'parent') {
      return isFree
        ? 'The price for this product is $0.00. Select a children to add this product to children profile?'
        : 'The price for this product is $0.00. Select a children to add this product to your cart?';
    } else {
      return isFree
        ? 'The price for this product is $0.00. Are you sure you want to add it to your profile?'
        : 'Would you like to add this product to your cart?';
    }
  };

  const option = purchaseOptions[0];
  const isFree = isProductFree(option);
  const parentText = getTextForRole('parent', isFree);
  const studentText = getTextForRole('student', isFree);

  useEffect(() => {
    fetchProfileFields();
  }, [freeProductId]);

  const fetchProfileFields = async () => {
    if (freeProductId) {
      try {
        setLoading(true);
        const response = await jwtAxios.get(
          `/profile-fields/product-profile/${freeProductId}`,
        );
        const { data } = response;
        setProfileFields(data.list);
        setLoading(false);
      } catch (error) {
        setProfileFields([]);
        setLoading(false);
      }
    }
  };

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = async (e) => { //NOSONAR
    e.preventDefault();
    setFormSubmitted(true);

    const errors = validateProductProfileFields(profileFields, formValues);
    setFieldErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        const fieldsData = serializeProductProfileFieldsPayload(
          formValues,
          profileFields,
          profileFields[0]?.product_id,
          profileFields[0]?.profile_id,
        );
        if (fieldsData?.length > 0) {
          let profileResponse = null;
          if (isParent(user) && membersData.length > 0 ? childId : user?.id) {
            profileResponse = await jwtAxios.post('/user-profiles', {
              user_id:
                isParent(user) && membersData.length > 0 ? childId : user?.id,
              product_id: freeProductId,
              profile_id: profileFields[0].profile_id,
            });
          }
          const userProfileId = profileResponse?.data?.id;
          if (userProfileId) {
            // Add profile data
            await jwtAxios.post('/user-profiles-data', {
              user_profile_id: userProfileId,
              fields: fieldsData,
            });
          }
        }
        if (freePurchaseOption && freeProductId) {
          await jwtAxios.post(`/product-members/${freeProductId}`, [
            {
              credit_option_id: freePurchaseOption,
              send_invitation: false,
              member_id:
                isParent(user) && membersData.length > 0 ? childId : user?.id,
            },
          ]);
          infoViewActionsContext.showMessage(
            `${product.product_name} added to profile successfully`,
          );
          handleClosePopup();
        }
        handleClosePopup();
        setFormValues({});
      } catch (error) {
        handleClosePopup();
        infoViewActionsContext.fetchError(error?.response?.data?.error);
      }
    }
  };

  const [enteredName, setEnteredName] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedWaiverData, setSelectedWaiverData] = useState(null);
  const userID = isParent(user) && membersData.length > 0 ? childId : user?.id;
  const handleOpen = (data) => {
    setSelectedWaiverData(data);
    setModalOpen(true);
  };

  const handleClose = () => {
    setSelectedWaiverData(null);
    setModalOpen(false);
  };

  useEffect(() => {
    if (
      isParent(user) && membersData.length > 0 && freeProductId
        ? freeProductId && childId
        : freeProductId && user.id
    ) {
      fetchWaiversData();
    }
  }, [freeProductId, childId, membersData?.length > 0, user?.id]);
  const fetchWaiversData = async () => {
    setLoading(true);
    try {
      const response = await jwtAxios.get(
        `/product-waiver-settings/user/${freeProductId}/${
          userID
        }`,
      );
      const { data } = response;
      setWaivers(data?.list);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('An error occurred while fetching waivers:', error);
    }
  };
  const profileFieldsKey = useMemo(
    () => getProfileFieldsStructureKey(profileFields),
    [profileFields],
  );

  useEffect(() => {
    if (!isFreePopupOpen || !profileFieldsKey || !userID) {
      return undefined;
    }

    let cancelled = false;

    const loadProfileFormValues = async () => {
      try {
        const response = await jwtAxios.get(`/user-profiles-data/${userID}`);
        if (cancelled) {
          return;
        }
        setFormValues(
          mapUserProfileDataToFormValues(response.data, profileFields),
        );
      } catch (error) {
        console.error('error', error);
      }
    };

    loadProfileFormValues();

    return () => {
      cancelled = true;
    };
  }, [isFreePopupOpen, userID, profileFieldsKey, profileFields]);
  const handleSave = async (userId, waiverData) => {
    try {
      await jwtAxios.post('/user-product-waivers', {
        user_id: userId ?? user?.id,
        product_waiver_id: waiverData?.id,
        signed: true,
        product_id: waiverData?.product_id,
        signed_by: user?.actualUser ? user?.actualUser : user?.id,
        signer_name: enteredName || '',
      });
      fetchWaiversData();
      setSelectedWaiverData(null);
      setModalOpen(false);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  useEffect(() => {
    if (
      isParent(user) && membersData.length > 0 && freeProductId
        ? freeProductId && childId
        : freeProductId && user?.id
    ) {
      fetchRequiredProfileFields();
    }
  }, [freeProductId, childId, membersData?.length > 0, user?.id]);

  const fetchRequiredProfileFields = async () => {
    try {
      const response = await jwtAxios.get(
        `/profile-fields/product/${freeProductId}/${user?.id}`,
      );

      const allData = response?.data?.list;
      const uniqueDataSet = new Set();
      const finalData = [];

      for (const item of allData) {
        const key = `${item.profile_field_id}_${item.profile_id}_${item.user_id}`;
        if (!uniqueDataSet.has(key)) {
          uniqueDataSet.add(key);
          finalData.push(item);
        }
      }
      setRequiredProfileFields(finalData);
    } catch (error) {
      setProfileFields([]);
    }
  };
  const handleClearFilter = () => {
    setActivityNameSorting(null);
    setStartDateSorting(null);
    setStartTimeSorting(null);
    setLocationSorting(null);
    setResourceSorting(null);
  };
  const renderCreditInfo = (data) => {
    if (data.credit_option === 0)
      return (
        <div>
          <p></p>
        </div>
      );
    if (data.check_here_for_unlimited_credits) return <div> ∞ Credits</div>;
    return <div> {data.credit_amount} Credits</div>;
  };

  const getButtonLabel = (data) => {
    let paymentText = '';

    if (data?.payment_plan_id) {
      if (data.payment_plan_id === 1) {
        paymentText = `Monthly Payment: $${data.remaining_amount}`;
      } else {
        paymentText = `Payments until ${data.payment_plan_id} Months: $${data.remaining_amount}`;
      }
    } else {
      paymentText = `Total: $${data.purchase_price}`;
    }
    if (data.is_deposit) {
      return (
        <div>
          Deposit ${data.deposit_amount}
          <br />
          {paymentText}
        </div>
      );
    } else if (data.monthly_price === '0.00') {
      return <div>${data.purchase_price}</div>;
    } else {
      return (
        <div>
          {data.payment_plan_label} ${data.monthly_price}
        </div>
      );
    }
  };

  const handleClick = (data, slug, user, onAddToCard) => {
    if (slug && !user) {
      window.open(`/signin?refurl=/products/${slug}`, '_blank');
    } else {
      let amount;

      if (data.is_deposit) {
        amount = data.deposit_amount;
      } else if (data.monthly_price === '0.00') {
        amount = data.purchase_price;
      } else {
        amount = data.monthly_price;
      }

      onAddToCard(
        amount,
        data.payment_plan_id,
        data.id,
        data.product_id,
        data.is_deposit,
        data.remaining_amount,
      );
    }
  };

  const renderPurchaseCard = (
    data,
    selectedTheme,
    slug,
    user,
    onAddToCard,
    isAdmin,
  ) => (
    <Grid
      key={data.id}
      sx={{
        display: 'block',
        marginBottom: 5,
        marginRight: 2,
        textAlign: 'center',
      }}
    >
      <div>
        <Typography variant='h3' sx={{ textAlign: 'center', marginBottom: 2 }}>
          <div>
            {data.option_label}
            {renderCreditInfo(data)}
          </div>
        </Typography>
        <Button
          variant='contained'
          color='primary'
          style={{
            backgroundColor: selectedTheme
              ? selectedTheme.primary.main
              : '#2196f3',
            margin: isAdmin ? 'auto' : undefined,
          }}
          onClick={() => handleClick(data, slug, user, onAddToCard)}
        >
          {getButtonLabel(data)}
        </Button>
      </div>
    </Grid>
  );

  const RenderWaivers = ({
    waivers,
    modalOpen,
    selectedWaiverData,
    verbiageSettings,
    handleOpen,
    handleClose,
    handleSave,
    enteredName,
    setEnteredName,
    childId,
    companyTheme,
  }) => {
    return waivers?.map((waiver) => (
      <Card key={waiver.id} style={{ margin: '10px', width: '95%' }}>
        <CardContent>
          <Typography variant='h4'>{waiver.waiver_name}</Typography>
          <Typography color='textSecondary'>
            {waiver.signed && waiver.saveClicked
              ? `${verbiageSettings.waiver_name || 'Waiver'} signed`
              : `Click to sign ${verbiageSettings.waiver_name || 'waiver'}`}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            sx={{
              position: 'relative',
              minWidth: 100,
              ml: 2.5,
              borderColor: companyTheme ? companyTheme.primary.main : '#2196f3',
              '&:hover': {
                borderColor: companyTheme
                  ? alpha(companyTheme.primary.main, 0.8)
                  : alpha('#2196f3', 0.8),
              },
              color: companyTheme ? companyTheme.primary.main : '#2196f3',
            }}
            variant={
              (waiver.signed && waiver.saveClicked) || !waiver.signed
                ? 'outlined'
                : 'contained'
            }
            onClick={() => handleOpen(waiver)}
            disabled={waiver.signed}
          >
            Sign {verbiageSettings.waiver_name || 'Waiver'}
          </Button>
        </CardActions>

        {modalOpen && waiver?.id === selectedWaiverData?.id && (
          <Modal
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby='modal-title'
            aria-describedby='modal-description'
          >
            <div className='waiver-pop'>
              <AppScrollbar className='waiver-scroll'>
                <DialogTitle
                  id='modal-title'
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '18px',
                  }}
                >
                  {selectedWaiverData?.waiver_name} Signature
                  <IconButton onClick={handleClose} aria-label='close'>
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id='modal-description'
                    style={{ color: '#000' }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          selectedWaiverData?.description ||
                          'No description found',
                      }}
                    />
                  </DialogContentText>
                  <DialogContentText
                    sx={{ marginTop: '10px', color: '#808080' }}
                  >
                    This is a legally binding document. I am {enteredName}, and
                    I agree to be legally bound by this digital signature. I
                    understand that I have the option to sign a paper copy
                    instead.
                  </DialogContentText>
                  <TextField
                    sx={{ mt: 6 }}
                    label={`Signer's Name`}
                    fullWidth
                    variant='outlined'
                    value={enteredName}
                    onChange={(e) => setEnteredName(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => handleSave(childId, selectedWaiverData)}
                    disabled={enteredName.trim() === ''}
                  >
                    Accept
                  </Button>
                </DialogActions>
              </AppScrollbar>
            </div>
          </Modal>
        )}
      </Card>
    ));
  };
  const sortedMembers = [...membersData];
  sortedMembers.sort((a, b) =>
    (a.first_name + ' ' + a.last_name).localeCompare(
      b.first_name + ' ' + b.last_name,
      undefined,
      { numeric: true, sensitivity: 'base' },
    ),
  );
  const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);
  const handleOpenWaitlist = () => {
    setIsWaitlistModalOpen(true);
  };

  const handleCloseWaitlist = () => {
    setIsWaitlistModalOpen(false);
  };

  return (
    <>
      {isMobile && (
        <Box onClick={() => setOpenSortingModal(true)} className='mt-15'>
          <span>Sort</span>
          <IconButton
            size='small'
            sx={{ fontWeight: 'bold' }}
            className='icon-btn'
          >
            <UnfoldMoreOutlined />
          </IconButton>
        </Box>
      )}
      {openSortingModal && (
        <SortingModalActivityMain
          isOpen={openSortingModal}
          onClose={() => setOpenSortingModal(false)}
          clearFilter={handleClearFilter}
          sortings={{
            activityNameSorting,
            setActivityNameSorting,
            startDateSorting,
            setStartDateSorting,
            startTimeSorting,
            setStartTimeSorting,
            locationSorting,
            setLocationSorting,
            resourceSorting,
            setResourceSorting,
          }}
          companyTheme={companyTheme}
        />
      )}
      <AppsHeader>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: 1,
          }}
        >
          <AppSearchBar
            iconPosition='right'
            overlap={false}
            onChange={onSearchActivity}
            placeholder={messages['common.searchHere']}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              ml: 'auto',
            }}
          >
            {!isSmallScreen && (
              <AppsPagination
                rowsPerPage={10}
                count={total}
                page={page}
                onPageChange={onPageChange}
              />
            )}
          </Box>
        </Box>
      </AppsHeader>
      {isSmallScreen && (
        <AppsPagination
          rowsPerPage={10}
          count={total}
          page={page}
          onPageChange={onPageChange}
        />
      )}
      <ActivityScheduleMain
        activityNameSorting={activityNameSorting}
        startDateSorting={startDateSorting}
        startTimeSorting={startTimeSorting}
        locationSorting={locationSorting}
        resourceSorting={resourceSorting}
        loading={loading}
        list={list}
        companyTheme={selectedTheme}
        user={user}
        handleSignUp={handleSignUp}
        handleWaitlist={handleWaitlist}
        handlePopUp={handlePopUp}
        slug={slug}
        StyledTableCell={StyledTableCell}
        isMobile={mobileResponsive}
        handleSort={handleSort}
      />
      <Dialog open={popupOpen} onClose={handleCancelPopUp} maxWidth='xl'>
        <DialogContent>
          <Grid
            size={{ xs: 12, sm: 12, md: 12 }}
            className='purchase-options'
            id='productpurchaseoption'
          >
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              {!isProductLimit ? (
                handleConditionFunction(
                  purchaseOptions?.length > 0,
                  <Box sx={{ marginBottom: 2 }}>
                    <DialogTitle>
                      <Typography variant='h2' sx={{ textAlign: 'center' }}>
                        Purchase Options
                      </Typography>
                    </DialogTitle>
                  </Box>,
                  <Box sx={{ marginBottom: 2 }}>
                    <Typography variant='h3'>
                      No Purchase Options Available
                    </Typography>
                  </Box>,
                )
              ) : (
                <Typography
                  variant='h3'
                  sx={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}
                >
                  This product is out of stock.
                  <br />
                  <Typography variant='body1'>
                    Join the waitlist to be notified when it's available again.
                  </Typography>
                </Typography>
              )}

              {!isProductLimit ? (
                <Box
                  className='purchase-buttons'
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                  }}
                >
                  {purchaseOptions?.filter(
                    (option) => option.membership_expiration_visible === 1,
                  ).length > 0
                    ? purchaseOptions
                        .filter(
                          (option) =>
                            option.membership_expiration_visible === 1,
                        )
                        .map((data) =>
                          renderPurchaseCard(
                            data,
                            selectedTheme,
                            slug,
                            user,
                            onAddToCard,
                            isSuperAdmin(user) || isAdmin(user),
                          ),
                        )
                    : 'No Purchase Options Available'}
                </Box>
              ) : (
                <Grid
                  sx={{
                    display: 'block',
                    marginBottom: 5,
                    textAlign: 'center',
                  }}
                >
                  <div>
                    <Button
                      variant='contained'
                      color='primary'
                      style={{
                        maxWidth: 200,
                        minWidth: 140,
                        backgroundColor: selectedTheme
                          ? selectedTheme.primary.main
                          : '#2196f3',
                      }}
                      onClick={() => {
                        if (slug) {
                          window.open(
                            `/signin?refurl=/products/${slug}`,
                            '_blank',
                          );
                        } else {
                          handleOpenWaitlist();
                        }
                      }}
                    >
                      Join the Waitlist
                    </Button>
                  </div>
                </Grid>
              )}
            </Box>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={isFreePopupOpen}
        onClose={handleClosePopup}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle>
          <Typography variant='h4'>Price Alert</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id='alert-dialog-description'
            sx={{ fontSize: '16px', fontWeight: 'bold' }}
          >
            {isParent(user) && membersData?.length > 0
              ? parentText
              : studentText}
          </DialogContentText>
          {loading ? (
            <AppLoader />
          ) : (
            <form onSubmit={handleSubmit}>
              {isParent(user) && membersData?.length > 0 && (
                <Grid size={{ xs: 12, md: 12 }}>
                  <Autocomplete
                    disableClearable
                    options={sortedMembers}
                    value={selectedUsers}
                    onChange={(event, newValue) => {
                      setSelectedUsers(newValue);
                      setChildId(newValue?.id);
                    }}
                    getOptionLabel={(option) =>
                      `${option.first_name} ${option.last_name}`
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label='Search Member'
                        name='member_id'
                        error={!isChildIdValid}
                        sx={{ mt: 4 }}
                        InputProps={{// NOSONAR - MUI v6 Autocomplete still requires InputProps for dropdown anchor
                          ...params.InputProps,
                          type: 'search',
                        }}
                      />
                    )}
                  />
                </Grid>
              )}

              {profileFields?.length > 0 && (
                  <>
                    <Typography variant='h3' sx={{ marginBottom: '10px' }}>
                      Profile Fields
                    </Typography>
                    <Grid container spacing={2}>
                      <ProductProfileFieldsGrid
                        profileFields={profileFields}
                        formValues={formValues}
                        formSubmitted={formSubmitted}
                        onChange={handleInputChange}
                        fieldErrors={fieldErrors}
                      />
                    </Grid>
                  </>
                )}

              {waivers?.length > 0 && (
                <Typography variant='h3' sx={{ marginTop: '10px' }}>
                  Waivers
                </Typography>
              )}
              <RenderWaivers
                waivers={waivers}
                modalOpen={modalOpen}
                selectedWaiverData={selectedWaiverData}
                verbiageSettings={verbiageSettings}
                handleOpen={handleOpen}
                handleClose={handleClose}
                handleSave={handleSave}
                enteredName={enteredName}
                setEnteredName={setEnteredName}
                childId={childId}
                companyTheme={companyTheme}
              />

              <Grid size={{ xs: 12, md: 12 }}>
                <Box mt={2}>
                  <Button
                    type='submit'
                    sx={{
                      position: 'relative',
                      minWidth: 100,
                      ml: 2.5,
                      backgroundColor: handleConditionFunction(
                        companyTheme,
                        companyTheme?.primary?.main,
                        '#2196f3',
                      ),

                      '&:hover': {
                        backgroundColor: handleConditionFunction(
                          companyTheme,
                          companyTheme
                            ? alpha(companyTheme?.primary?.main, 0.8)
                            : null,
                          alpha('#2196f3', 0.8),
                        ),
                      },
                    }}
                    disabled={
                      (!isChildIdValid && isParent(user)) || waivers.length > 0
                    }
                    variant='contained'
                  >
                    Add Product
                  </Button>
                  <Button
                    sx={{
                      position: 'relative',
                      minWidth: 100,
                      ml: 2.5,
                      borderColor: handleConditionFunction(
                        companyTheme,
                        companyTheme?.primary?.main,
                        '#2196f3',
                      ),

                      '&:hover': {
                        borderColor: handleConditionFunction(
                          companyTheme,
                          companyTheme
                            ? alpha(companyTheme?.primary?.main, 0.8)
                            : null,
                          alpha('#2196f3', 0.8),
                        ),
                      },
                      color: handleConditionFunction(
                        companyTheme,
                        companyTheme?.primary?.main,
                        '#2196f3',
                      ),
                    }}
                    variant='outlined'
                    onClick={handleClosePopup}
                    type='button'
                  >
                    Cancel
                  </Button>
                </Box>
              </Grid>
            </form>
          )}
        </DialogContent>
      </Dialog>
      {isWaitlistModalOpen && (
        <WaitlistModal
          open={isWaitlistModalOpen}
          onClose={handleCloseWaitlist}
          productName={product?.product_name}
          productId={product?.id}
          userId={user?.id}
          userEmail={user?.email}
          userMobile={user?.mobile}
          userName={`${user?.first_name || ''} ${user?.last_name || ''}`.trim()}
          companyTheme={companyTheme}
          infoViewActionsContext={infoViewActionsContext}
        />
      )}
      {isErrorDialogOpen && (
        <RestrictedPopupDialog
          setIsErrorDialogOpen={setIsErrorDialogOpen}
          isErrorDialogOpen={isErrorDialogOpen}
        />
      )}
    </>
  );
};
ActivitySchedule.propTypes = {
  product_Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired, // Accepts string or number
  product: PropTypes.object.isRequired, // Assuming product is an object; adjust as needed
  purchaseOptions: PropTypes.array.isRequired, // Assuming it's an array
  slug: PropTypes.string.isRequired, // Slug must be a string
};

export default ActivitySchedule;
